import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
const ClickableText = ({ onClick, children, className, ...props }) => {
    return (_jsx("span", { ...props, onClick: onClick, onKeyDown: (e) => {
            if (e.key === "Enter") {
                onClick?.();
            }
        }, className: clsx("text-sm", "cursor-pointer", "relative", "inline-block", "w-fit", "after:content-['']", "after:absolute", "after:w-full", "after:h-[2px]", "after:bg-current", "after:bottom-0", "after:left-0", "after:opacity-100", "hover:after:hidden", "before:content-['']", "before:absolute", "before:w-0", "before:h-[2px]", "before:bg-current", "before:bottom-0", "before:left-0", "before:opacity-0", "hover:before:animate-underlineSlide", className), tabIndex: 0, children: children }));
};
export default ClickableText;
//# sourceMappingURL=ClickableText.js.map